import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/shared/components/ui/dialog';
import { Progress } from '@/shared/components/ui/progress';

interface CleanupProgressDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  progress: number;
  entityName: string | undefined;
  translationPrefix: string;
}

export function CleanupProgressDialog({ open, onOpenChange, progress, entityName, translationPrefix }: CleanupProgressDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center">{t(`${translationPrefix}.deletingTitle`)}</DialogTitle>
          <DialogDescription className="text-center">
            {t(`${translationPrefix}.deletingDescription`, { name: entityName || '' })}
          </DialogDescription>
        </DialogHeader>
        <div className="py-6">
          <div className="space-y-4">
            <div className="space-y-2">
              <div className="flex justify-between text-sm text-muted-foreground">
                <span>{t(`${translationPrefix}.deletingStep`)}</span>
                <span className="font-medium">{Math.round(progress)}%</span>
              </div>
              <Progress value={progress} className="h-2" />
              <p className="text-xs text-center text-muted-foreground mt-2">
                {progress < 100
                  ? t(`${translationPrefix}.deletingMessage`)
                  : t(`${translationPrefix}.deletedMessage`)}
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
